import * as React from "react";
import AboutColor from "../containers/AboutColor";
import redQuotation from "../containers/AboutColor/redQuotation";
import redParrot from "../containers/AboutColor/redParrot.png";
import COLOR_TYPES from "../common/colors/type";
import t from "../translations";

export default (props) => (
  <AboutColor
    {...props}
    authorName={t("routes_RedAboutColorsPageRoute_autorName")}
    title={t("routes_RedAboutColorsPageRoute_title")}
    image={redParrot}
    quotation={redQuotation}
    colorType={COLOR_TYPES.RED}
  />
);
